





































































































































































































































































import * as fb from '@/firebase';
import router from '@/router';
import * as store from '@/store';
import * as _ from 'lodash';
import { UserModule } from '@/store/modules/user';
import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { Component, Prop, Vue } from 'vue-property-decorator';

import ErrorWrappedAnything from '@/components/form-elements/ErrorWrappedAnything.vue';
import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';

@Component({ components: { ErrorWrappedTextInput } })
export default class AddEditList extends Vue {
  @Prop(Boolean) public editMode: boolean;
  @Prop(ListModel) public list: ListModel;
  public origTitle: string = this.list.title;
  tag: string = '';
  readonly oldList: ListModel = _.clone(this.list);

  toggleVisibility() {
    this.list.isListed = !this.list.isListed;
  }

  removeTag(tag: string) {
    this.list.tags = this.list.tags.filter(t => t != tag);
  }

  addTag() {
    const myTag = this.tag.trim();
    if (this.list.tags.indexOf(myTag) == -1 && !!myTag) {
      this.list.tags.push(myTag);
    }
    this.tag = '';
  }

  private async submit(evt: Event) {
    evt.preventDefault();
    let isValid = await this.$validator.validateAll();
    if (isValid) {
      if (this.editMode) {
        ListModelUtil.updateList({
          oldList: this.oldList,
          list: this.list,
          shouldUpdateModifiedTime: true,
          user: UserModule.userProfile
        }).then(() => {
          router.push(this.list.link);
        });
      } else {
				console.log('writing list', this.list)
        ListModelUtil.writeList(this.list, UserModule.userProfile).then(() => {
          router.push(this.list.link);
        });
      }
    }
    return true;
  }
}
